import { network } from 'services/network';

interface QueryParams {
    reportId: number;
}

export interface ReportComment {
    reportId: number;
    commentId: number;
    comment: string;
    firstName: string;
    lastName: string;
    updatedDate: number;
    userName: string;
    imageName: string;
}

export const getReportComments = (params: QueryParams): Promise<ReportComment[]> => {
    const url = `api/bo/reporting/getReportComments?reportId=${params.reportId}`;
    return network.post<ReportComment[]>(url).then((response) => {
        return response.data;
    });
};
